var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-input',{ref:"input",staticClass:"live-editor-cell__textarea",class:{ 'live-editor-cell__textarea--scroll': _vm.scrollable },attrs:{"type":"textarea","autosize":_vm.autosize,"size":"mini","value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }